import Cookies from "js-cookie";

export const BASE_URL =
  process.env.REACT_APP_SERVER_URL || "https://api.hyper.itmsgh.com";
// "http://localhost:8068"

export const S3_FILE_UPLOAD_ENDPOINT = "https://cx6hg35vb0.execute-api.eu-west-1.amazonaws.com/api/upload-stream";

export const THUMBNAIL_UPLOAD_ENDPOINT = "https://cx6hg35vb0.execute-api.eu-west-1.amazonaws.com/api/getUploadSignedUrl";

export const POSTS_API_URL =
  "https://tapngo-social-api-df1ef466d876.herokuapp.com";

export const BASE_URL2 =
  process.env.REACT_APP_SERVER_URL || "https://api.mmt.itmsgh.com";
// "http://localhost:3030";

class Auth { 
  getCipher() {
    return sessionStorage.getItem("/t") || null;
  }

  setCipher(token, data = {}) {
    sessionStorage.setItem("/t", token);
    sessionStorage.setItem("/r", data?.role);
    // sessionStorage
    // Cookies.set("/t", token);
    // Cookies.set("/r", data?.role);
    sessionStorage.setItem("data", JSON.stringify(data));
  }

  clearCipher() {
    Cookies.remove("/t");
    sessionStorage.clear();
  }
}

export default new Auth();
